import React from 'react'

export const defaultValue = {
}

export const UserContext = React.createContext(defaultValue)

